const sportList = [
  { label: "Aerobics", value: 1 },
  { label: "Archery", value: 2 },
  { label: "Badminton", value: 3 },
  { label: "Baduanjin Qigong", value: 4 },
  { label: "Baseball", value: 5 },
  { label: "Basketball", value: 6 },
  { label: "BodyCombat", value: 7 },
  { label: "Bodyweight Exercises", value: 8 },
  { label: "Bouldering", value: 9 },
  { label: "Boxing", value: 10 },
  { label: "Brisk Walking", value: 11 },
  { label: "Chinese Kickboxing", value: 12 },
  { label: "Climbing", value: 13 },
  { label: "Combat Aerobics", value: 14 },
  { label: "Cycling", value: 15 },
  { label: "Curling", value: 16 },
  { label: "Dance", value: 17 },
  { label: "Diving", value: 18 },
  { label: "Elliptical", value: 19 },
  { label: "Equipment Training", value: 20 },
  { label: "Esports", value: 21 },
  { label: "Frisbee", value: 22 },
  { label: "Golf", value: 23 },
  { label: "Gym", value: 24 },
  { label: "Hiking", value: 25 },
  { label: "Horse Riding", value: 26 },
  { label: "Ice Hockey", value: 27 },
  { label: "Ice Skating", value: 28 },
  { label: "Jogging", value: 29 },
  { label: "Jump Rope", value: 30 },
  { label: "Kayak", value: 31 },
  { label: "Martial Arts", value: 32 },
  { label: "Muay Thai", value: 33 },
  { label: "Netball", value: 34 },
  { label: "Paddle Ball", value: 35 },
  { label: "Paddling", value: 36 },
  { label: "Padel Ball", value: 37 },
  { label: "Physical Therapy Exercises", value: 38 },
  { label: "Pickleball", value: 39 },
  { label: "Pilates", value: 40 },
  { label: "Pool", value: 41 },
  { label: "Rock Climbing", value: 42 },
  { label: "Roller Skating", value: 43 },
  { label: "Rowing", value: 44 },
  { label: "Running", value: 45 },
  { label: "Sailing", value: 46 },
  { label: "Skateboarding", value: 47 },
  { label: "Skiing", value: 48 },
  { label: "Slow Jogging", value: 49 },
  { label: "Slow Walk", value: 50 },
  { label: "Snowboard", value: 51 },
  { label: "Soaring Crane Qigong", value: 52 },
  { label: "Soccer", value: 53 },
  { label: "Softball", value: 54 },
  { label: "Sprinting", value: 55 },
  { label: "Squash", value: 56 },
  { label: "Stretching", value: 57 },
  { label: "Surfing", value: 58 },
  { label: "Swimming", value: 59 },
  { label: "Tabata Workouts", value: 60 },
  { label: "Table Tennis", value: 61 },
  { label: "Taekwondo", value: 62 },
  { label: "Taiqi", value: 63 },
  { label: "Tennis", value: 64 },
  { label: "Tree Climbing", value: 65 },
  { label: "Volleyball", value: 66 },
  { label: "Walking", value: 67 },
  { label: "Weightlifting", value: 68 },
  { label: "Yoga", value: 69 },
  { label: "Zumba", value: 70 }
];

export default sportList;
